import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

import cl from './styles.module.scss';

export const Swiping = () => {
  return (
    <div className={cl.swiping}>
      <span className={cl.title}>Смахивание</span>
      <div className={cl.wrap}>
        <div className={cl.left}>
          <ArrowLeftOutlined style={{ color: '#5C934A', fontSize: 12 }} />
          <span>ввести причину</span>
        </div>
        <div className={cl.right}>
          <ArrowRightOutlined style={{ color: '#5C934A', fontSize: 12 }} />
          <span>подтвердить</span>
        </div>
      </div>
    </div>
  );
};
